import { type ProductHeadLabel } from './ProductHeadLabelsTypes'

export const productHeadLabelsSortSellerPromotionLabels = (
  labelA: ProductHeadLabel,
  labelB: ProductHeadLabel,
): number => {
  const isSellerPromotionA = labelA.type === 'sellerPromotion'
  const isSellerPromotionB = labelB.type === 'sellerPromotion'
  if (isSellerPromotionA && !isSellerPromotionB) {
    return -1
  }
  if (!isSellerPromotionA && isSellerPromotionB) {
    return 1
  }

  return 0
}
